// Busca da tela de Campo (#6505): as rotas do motoboy com as paradas. A regra está em
// src/lib/visaoGeral/campo.ts.
import { useEffect, useState } from 'react';
import { supabase } from '../../src/lib/supabase';
import type { RotaDoMotoboy } from '../../src/lib/visaoGeral/campo';

/**
 * As últimas 60 rotas da pessoa, com as paradas e a negociação de cada uma (endereço da UC
 * para navegar). Inclui as canceladas: visita feita em rota cancelada também conta.
 */
export function useRotasDoMotoboy(pessoaId: string): { rotas: RotaDoMotoboy[] | null; erro: boolean } {
  const [estado, setEstado] = useState<{ rotas: RotaDoMotoboy[] | null; erro: boolean }>({ rotas: null, erro: false });
  useEffect(() => {
    let vivo = true;
    setEstado({ rotas: null, erro: false });
    supabase.from('rotas_comerciais')
      .select('id, nome, data, status, rota_paradas(id, posicao, status, negociacao_id, visitado_em, numero_medidor, negociacoes(id, titulo, cidade, bairro, latitude, longitude, geocode_status, consumo_medio_kwh, status, stage, unidades_consumidoras(logradouro, numero, bairro, cidade, cep)))')
      .eq('vendedor_id', pessoaId)
      .order('data', { ascending: false })
      .limit(60)
      .then(({ data, error }) => {
        if (!vivo) return;
        if (error) { console.error('Rotas do motoboy:', error); setEstado({ rotas: [], erro: true }); return; }
        setEstado({ rotas: (data || []) as unknown as RotaDoMotoboy[], erro: false });
      });
    return () => { vivo = false; };
  }, [pessoaId]);
  return estado;
}
